import gql from 'graphql-tag';

export const fields = `
    name
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginatePotentialIssues (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginatePotentialIssues (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetPotentialIssues (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetPotentialIssues (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindPotentialIssueById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindPotentialIssueById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindPotentialIssue (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindPotentialIssue (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreatePotentialIssue (
        $payload: DigitaiCreatePotentialIssueInput!
    ) {
        digitaiCreatePotentialIssue (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdatePotentialIssueById (
        $payload: DigitaiUpdatePotentialIssueByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdatePotentialIssueById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdatePotentialIssues (
        $payload: DigitaiUpdatePotentialIssuesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdatePotentialIssues (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeletePotentialIssueById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeletePotentialIssueById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeletePotentialIssues (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeletePotentialIssues (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
